import type { ElementType, PropsWithChildren, ReactNode } from 'react'
import type { UseSortableArguments } from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

type SortableProps = UseSortableArguments & PropsWithChildren & { as?: ElementType }

export default function Sortable({ children, as = 'li', ...rest }: SortableProps): ReactNode {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ ...rest })

  const Component = as

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Component style={style} ref={setNodeRef} {...attributes} {...listeners}>
      {children}
    </Component>
  )
}
